import { render, staticRenderFns } from "./Hotmart.vue?vue&type=template&id=ccaf198a&"
import script from "./Hotmart.vue?vue&type=script&lang=js&"
export * from "./Hotmart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports